<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import ptBrLocale from '@fullcalendar/core/locales/pt-br'
import SessionStorage from '@/services/session-storage'
import Vue from 'vue'
import moment from 'moment'

export default {
  components: {
    FullCalendar
  },
  data () {
    return {
      calendarPlugins: [ dayGridPlugin ],
      locale: ptBrLocale,
      firstDay: 1, // Segunda-feira
      titleFormat: { year: 'numeric', month: 'long' },
      events: [],
      displayEventTime: true,
      displayEventEnd: true,
      eventTimeFormat: {
        hour: 'numeric',
        minute: '2-digit',
        meridiem: false
      }
    }
  },
  created () {
    this.$store.dispatch('getUsuario', SessionStorage.get('usuario'))

    let perfil = SessionStorage.get('tipoPerfil')

    perfil = perfil.replace(/['"]+/g, '')

    if (!perfil) {
      perfil = 'nenhum'
    }

    if (perfil !== 'V') {
      this.$router.push('/')
    }
  },
  methods: {
    requestSchedulerData (currentYear, currentMonth) {
      let data = {params: {year: parseInt(currentYear), month: parseInt(currentMonth)}}

      Vue.http.get('api/voluntario/calendario', data).then(response => {
        this.events = response.body
      })
    },
    ticketEventRender: function (info) {
      info.el.querySelector('.fc-title').innerHTML = '<br /><strong title="' + info.event.title + '">' + info.event.title + '</strong>'
      info.el.querySelector('.fc-content').innerHTML += '<br /><span class="fc-local" title="' + info.event.extendedProps.local + '"><strong>Local:</strong>' + info.event.extendedProps.local + '</span>'
    },
    handleMonthChange: function (arg) {
      var currentStart = arg.view.currentStart
      var check = moment(currentStart, 'YYYY/MM/DD')
      var currentMonth = check.format('M')
      var currentYear = check.format('Y')

      this.requestSchedulerData(currentYear, currentMonth)
    }
  }
}
</script>

<style>
  @import '../../../../../../../node_modules/@fullcalendar/core/main.css';
  @import '../../../../../../../node_modules/@fullcalendar/daygrid/main.css';

  .fc-view-container {
    background-color: #fff;
  }
</style>

<template>
  <b-card>
    <b-card-header>
      <b-row>
        <b-col md="9">
          <h3>Calendário</h3>
        </b-col>
      </b-row>
    </b-card-header>
    <b-card-body>
      <FullCalendar defaultView="dayGridMonth" :plugins="calendarPlugins" :locale="locale" :firstDay="firstDay" :titleFormat="titleFormat" :events="events" :eventRender="ticketEventRender" :displayEventTime="displayEventTime" :displayEventEnd="displayEventEnd" :eventTimeFormat="eventTimeFormat" @datesRender="handleMonthChange" />
    </b-card-body>
  </b-card>
</template>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/usuarios/voluntario/Calendario.vue